
import { Highlight } from "@/utils/views/highlight";
import Vue from "vue";
import { Model } from "@/utils/models/model";
import AppHighlightEditConditions from "./HighlightEditConditions.vue";
import AppHighlightEditStyle from "./HighlightEditStyle.vue";
import { Browse } from "@/models/browse";

export default Vue.extend({
	data(){
		return {
			highlight: new Highlight(),
			currentTab: 0
		};
	},
	props: {
		value: {
			type: Object as ()=>Highlight,
			required: true
		},
		model: {
			type: Object as ()=>Model,
			required: true
		},
		browse: {
			type: Object as ()=>Browse,
			required: true
		}
	},
	computed: {
		tabs():string[]{
			return ["style", "conditions"].map(s=>this.$ct(s).toString());
		}
	},
	watch: {
		value: {
			immediate: true,
			handler(){
				this.highlight = new Highlight(this.value.getJSON());
			}
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		confirm(){
			this.$emit("input", new Highlight(this.highlight.getJSON()));
			this.close();
		},

	},
	components: {
		AppHighlightEditConditions,
		AppHighlightEditStyle
	},
	i18nEx: {
		componentPrefix: "components.view-editor"
	}
});
